import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgStore = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M20.02 10a1 1 0 0 1 .993.883l.007.117v10a1 1 0 0 1-.884.993L20.02 22h-16a1 1 0 0 1-.994-.883L3.02 21V11a1 1 0 0 1 1.993-.117L5.02 11l-.001 9h14v-9a1 1 0 0 1 .884-.993L20.02 10Z" />
      <path d="M19.617 2H4.423a1 1 0 0 0-.933.64L1.988 6.528C.971 9.163 2.928 12 5.755 12l.2-.005a4.003 4.003 0 0 0 2.698-1.233l.108-.12.11.12A3.989 3.989 0 0 0 11.763 12h.509l.2-.005a3.988 3.988 0 0 0 2.693-1.233l.109-.12.109.12A4.004 4.004 0 0 0 18.283 12c2.827 0 4.786-2.838 3.768-5.474L20.55 2.64a1 1 0 0 0-.933-.64ZM5.108 4h13.823l1.254 3.247C20.696 8.569 19.708 10 18.283 10a2.01 2.01 0 0 1-2.004-1.851L16.273 8c0-1.287-1.864-1.332-1.993-.133L14.273 8a2 2 0 0 1-2 2h-.51A2 2 0 0 1 9.77 8.15L9.764 8c0-1.287-1.865-1.332-1.993-.133L7.764 8c0 1.102-.902 2-2.01 2l-.145-.005c-1.345-.093-2.248-1.47-1.755-2.746L5.108 4Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgStore)
const Memo = memo(ForwardRef)
export default Memo
